import React from 'react'
import PropTypes from 'prop-types'
import { Button } from 'react-bootstrap'
import cx from 'classnames'
import ReactLoading from 'react-loading'

class FloatingSpinner extends React.Component {
  render() {
    const spinnerStyle = cx('float', 'spin', { active: this.props.show })

    return (
      <Button bsSize={this.props.bsSize} bsStyle={this.props.bsStyle} className={spinnerStyle}>
        <ReactLoading type='spinningBubbles' style={{ fill: 'white', width: '14px', height: '14px', margin: 'auto' }}/>
      </Button>
    )
  }
}

FloatingSpinner.defaultProps = {
  show: false
}

FloatingSpinner.propTypes = {
  bsSize: PropTypes.string,
  bsStyle: PropTypes.string,
  show: PropTypes.bool,
}

export default FloatingSpinner



// WEBPACK FOOTER //
// ./src/components/widgets/FloatingSpinner.js